import type { IAudienceTemplate } from '@/Interfaces/AudienceTemplates/AudienceTemplate.interface';
import { Delete, Edit } from '@mui/icons-material';
import { Button, IconButton, List, ListItem, ListItemText, Skeleton } from '@mui/material';

interface IProps {
  templates: IAudienceTemplate[];
  loading: boolean;
  isAdmin: boolean;
  onApply: (template: IAudienceTemplate) => void;
  onEdit: (template: IAudienceTemplate) => void;
  onDelete: (template: IAudienceTemplate) => void;
}

const TemplatesList = ({ templates, loading, isAdmin, onApply, onEdit, onDelete }: IProps) => {
  if (loading) {
    return <Skeleton variant='rectangular' height={200} />;
  }

  if (!templates.length) {
    return <p className='text-gray-500 py-6 text-center'>No templates yet.</p>;
  }

  return (
    <List>
      {templates.map(template => (
        <ListItem
          key={template.id}
          secondaryAction={
            <div className='flex items-center gap-2'>
              <Button size='small' variant='outlined' onClick={() => onApply(template)}>
                Apply
              </Button>
              {isAdmin && (
                <>
                  <IconButton aria-label='Edit template' onClick={() => onEdit(template)}>
                    <Edit fontSize='small' />
                  </IconButton>
                  <IconButton aria-label='Delete template' onClick={() => onDelete(template)}>
                    <Delete fontSize='small' />
                  </IconButton>
                </>
              )}
            </div>
          }
        >
          <ListItemText primary={template.name} secondary={template.description ?? undefined} />
        </ListItem>
      ))}
    </List>
  );
};

export default TemplatesList;
